// extracted by mini-css-extract-plugin
export default {"login":"login_login__NmGXK","image":"login_image__fChkN","input":"login_input__-lc6g","button":"login_button__mJeqB"};